// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Tools from "../Tools.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ProfileName from "./ProfileName.bs.js";
import * as ProfileEmail from "./ProfileEmail.bs.js";
import * as ProfilePhone from "./ProfilePhone.bs.js";
import * as ProfileFamily from "./ProfileFamily.bs.js";
import * as ProfileGender from "./ProfileGender.bs.js";
import * as ProfileAddress from "./ProfileAddress.bs.js";
import * as ProfileBirthdate from "./ProfileBirthdate.bs.js";

function empty(param) {
  return /* Consent */{
          privacy: false,
          term: false
        };
}

function checkPDPA(c) {
  if (c.term) {
    return {
            TAG: /* Ok */0,
            _0: c
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: undefined
          };
  }
}

function toggleAction(x, c) {
  if (x) {
    return /* Consent */{
            privacy: c.privacy,
            term: !c.term
          };
  } else {
    return /* Consent */{
            privacy: !c.privacy,
            term: c.term
          };
  }
}

function toJson(c) {
  return Js_dict.fromList({
              hd: [
                "privacy_policy",
                Js_dict.fromList({
                      hd: [
                        "has_accept",
                        c.privacy
                      ],
                      tl: /* [] */0
                    })
              ],
              tl: {
                hd: [
                  "terms_and_conditions",
                  Js_dict.fromList({
                        hd: [
                          "has_accept",
                          c.term
                        ],
                        tl: /* [] */0
                      })
                ],
                tl: /* [] */0
              }
            });
}

var PDPA = {
  empty: empty,
  checkPDPA: checkPDPA,
  toggleAction: toggleAction,
  toJson: toJson
};

function checkFirstName(x) {
  return Belt_Result.map(ProfileName.checkName(x), (function (x) {
                return x;
              }));
}

function checkLastName(x) {
  return Belt_Result.map(ProfileName.checkName(x), (function (x) {
                return x;
              }));
}

function checkMobilePhone(x) {
  return Belt_Result.map(ProfilePhone.checkMobilePhone(x), (function (x) {
                return x;
              }));
}

function checkEmail(x) {
  return Belt_Result.map(ProfileEmail.checkEmail(x), (function (x) {
                return x;
              }));
}

function checkHookProfile(data) {
  var d = Js_json.classify(data);
  var json;
  json = typeof d === "number" ? ({}) : (
      d.TAG === /* JSONObject */2 ? d._0 : ({})
    );
  var x = Belt_Option.flatMap(Js_dict.get(json, "firstname"), Js_json.decodeString);
  var x$1 = Belt_Option.flatMap(Js_dict.get(json, "lastname"), Js_json.decodeString);
  var x$2 = Belt_Option.flatMap(Js_dict.get(json, "mobile"), Js_json.decodeString);
  var x$3 = Belt_Option.flatMap(Js_dict.get(json, "email"), Js_json.decodeString);
  var x$4 = Belt_Option.flatMap(Js_dict.get(json, "address"), Js_json.decodeObject);
  var x$5 = Belt_Option.flatMap(Js_dict.get(json, "pdpa"), Js_json.decodeObject);
  var tmp;
  if (x$5 !== undefined) {
    var d$1 = Caml_option.valFromOption(x$5);
    var privacy = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(Js_dict.get(d$1, "privacy_policy"), Js_json.decodeObject), (function (__x) {
                    return Js_dict.get(__x, "has_accept");
                  })), Js_json.decodeBoolean), false);
    var term = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(Js_dict.get(d$1, "terms_and_conditions"), Js_json.decodeObject), (function (__x) {
                    return Js_dict.get(__x, "has_accept");
                  })), Js_json.decodeBoolean), false);
    tmp = /* Consent */{
      privacy: privacy,
      term: term
    };
  } else {
    tmp = /* Consent */{
      privacy: false,
      term: false
    };
  }
  return {
          TAG: /* Ok */0,
          _0: {
            firstname: x !== undefined ? checkFirstName(x) : ({
                  TAG: /* Ok */0,
                  _0: undefined
                }),
            lastname: x$1 !== undefined ? checkLastName(x$1) : ({
                  TAG: /* Ok */0,
                  _0: undefined
                }),
            gender: Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Js_dict.get(json, "gender"), Js_json.decodeString), ProfileGender.fromString), /* FEMALE */0),
            mobile: x$2 !== undefined ? checkMobilePhone(x$2) : ({
                  TAG: /* Ok */0,
                  _0: undefined
                }),
            email: x$3 !== undefined ? checkEmail(x$3) : ({
                  TAG: /* Ok */0,
                  _0: undefined
                }),
            birthdate: ProfileBirthdate.fromISODateString(Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(json, "birthdate"), Js_json.decodeString), "1987-01-01")),
            address: x$4 !== undefined ? ProfileAddress.fromJson(Caml_option.valFromOption(x$4)) : ({
                  TAG: /* Error */1,
                  _0: ProfileAddress.empty(undefined)
                }),
            occupation: Belt_Option.flatMap(Js_dict.get(json, "occupation"), Js_json.decodeString),
            family: Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Js_dict.get(json, "family"), Js_json.decodeString), ProfileFamily.fromString), /* Single */0),
            pdpa: tmp
          }
        };
}

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* ChangeState */0 :
        return action._0;
    case /* ChangeFirstName */1 :
        return {
                firstname: checkFirstName(action._0),
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeLastName */2 :
        return {
                firstname: state.firstname,
                lastname: checkLastName(action._0),
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeGender */3 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: action._0,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeMobile */4 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: checkMobilePhone(action._0),
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeEmail */5 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: checkEmail(action._0),
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeBirthdateDay */6 :
        var init = state.birthdate;
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: {
                  day: action._0,
                  month: init.month,
                  year: init.year
                },
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeBirthdateMonth */7 :
        var init$1 = state.birthdate;
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: {
                  day: init$1.day,
                  month: action._0,
                  year: init$1.year
                },
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeBirthdateYear */8 :
        var init$2 = state.birthdate;
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: {
                  day: init$2.day,
                  month: init$2.month,
                  year: action._0
                },
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeFamily */9 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: action._0,
                pdpa: state.pdpa
              };
    case /* ChangeAddress */10 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: action._0,
                occupation: state.occupation,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangeOccupation */11 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: action._0,
                family: state.family,
                pdpa: state.pdpa
              };
    case /* ChangePDPA */12 :
        return {
                firstname: state.firstname,
                lastname: state.lastname,
                gender: state.gender,
                mobile: state.mobile,
                email: state.email,
                birthdate: state.birthdate,
                address: state.address,
                occupation: state.occupation,
                family: state.family,
                pdpa: toggleAction(action._0, state.pdpa)
              };
    
  }
}

var initial_state_firstname = {
  TAG: /* Ok */0,
  _0: undefined
};

var initial_state_lastname = {
  TAG: /* Ok */0,
  _0: undefined
};

var initial_state_mobile = {
  TAG: /* Ok */0,
  _0: undefined
};

var initial_state_email = {
  TAG: /* Ok */0,
  _0: ""
};

var initial_state_birthdate = {
  day: 1,
  month: 1,
  year: ProfileBirthdate.YearUs.fromYearTh(ProfileBirthdate.YearTh.fromInt(2530))
};

var initial_state_address = {
  TAG: /* Ok */0,
  _0: ProfileAddress.empty(undefined)
};

var initial_state_pdpa = /* Consent */{
  privacy: false,
  term: false
};

var initial_state = {
  firstname: initial_state_firstname,
  lastname: initial_state_lastname,
  gender: /* FEMALE */0,
  mobile: initial_state_mobile,
  email: initial_state_email,
  birthdate: initial_state_birthdate,
  address: initial_state_address,
  occupation: undefined,
  family: /* Single */0,
  pdpa: initial_state_pdpa
};

function getValue(x) {
  if (x.TAG === /* Ok */0) {
    return Belt_Option.getWithDefault(x._0, "");
  } else {
    return x._0;
  }
}

function checkState(state) {
  var r = Belt_Result.flatMap(Belt_Result.flatMap(Belt_Result.flatMap(Belt_Result.flatMap(Belt_Result.flatMap(Belt_Result.flatMap(Tools.okNotEmpty(state.firstname), (function (param) {
                              return Tools.okNotEmpty(state.lastname);
                            })), (function (param) {
                          return Tools.okNotEmpty(state.mobile);
                        })), (function (param) {
                      return Tools.okNotEmpty(state.email);
                    })), (function (param) {
                  var x = state.address;
                  if (x.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: x._0
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: undefined
                          };
                  }
                })), (function (param) {
              return Tools.toOk(state.occupation);
            })), (function (param) {
          return checkPDPA(state.pdpa);
        }));
  if (r.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: state
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: undefined
          };
  }
}

function toJson$1(s, lead_in_channel) {
  return Js_dict.fromList(Belt_List.flatten({
                  hd: {
                    hd: [
                      "firstname",
                      getValue(s.firstname)
                    ],
                    tl: /* [] */0
                  },
                  tl: {
                    hd: {
                      hd: [
                        "lastname",
                        getValue(s.lastname)
                      ],
                      tl: /* [] */0
                    },
                    tl: {
                      hd: {
                        hd: [
                          "birthdate",
                          ProfileBirthdate.toISODateString(s.birthdate)
                        ],
                        tl: /* [] */0
                      },
                      tl: {
                        hd: {
                          hd: [
                            "gender",
                            ProfileGender.toString(s.gender)
                          ],
                          tl: /* [] */0
                        },
                        tl: {
                          hd: {
                            hd: [
                              "mobile",
                              getValue(s.mobile)
                            ],
                            tl: /* [] */0
                          },
                          tl: {
                            hd: {
                              hd: [
                                "email",
                                getValue(s.email)
                              ],
                              tl: /* [] */0
                            },
                            tl: {
                              hd: {
                                hd: [
                                  "address",
                                  ProfileAddress.toJson(Belt_Result.getExn(s.address))
                                ],
                                tl: /* [] */0
                              },
                              tl: {
                                hd: {
                                  hd: [
                                    "pdpa",
                                    toJson(s.pdpa)
                                  ],
                                  tl: /* [] */0
                                },
                                tl: {
                                  hd: {
                                    hd: [
                                      "lead_in_channel",
                                      lead_in_channel
                                    ],
                                    tl: /* [] */0
                                  },
                                  tl: {
                                    hd: {
                                      hd: [
                                        "occupation",
                                        Belt_Option.getExn(s.occupation)
                                      ],
                                      tl: /* [] */0
                                    },
                                    tl: {
                                      hd: {
                                        hd: [
                                          "family",
                                          ProfileFamily.toString(s.family)
                                        ],
                                        tl: /* [] */0
                                      },
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

function parseCoupons(data) {
  return Belt_Array.map(Belt_Option.getWithDefault(Belt_Option.flatMap(data, Js_json.decodeArray), []), (function (d) {
                var d$1 = Belt_Option.getExn(Js_json.decodeObject(d));
                return {
                        brand: Belt_Option.getExn(Belt_Option.flatMap(Js_dict.get(d$1, "brand"), Js_json.decodeString)),
                        code: Belt_Option.getExn(Belt_Option.flatMap(Js_dict.get(d$1, "code"), Js_json.decodeString))
                      };
              }));
}

function getCoupons(hook_profile) {
  var d = Js_json.classify(hook_profile);
  if (typeof d === "number") {
    return [];
  } else if (d.TAG === /* JSONObject */2) {
    return parseCoupons(Js_dict.get(d._0, "coupons"));
  } else {
    return [];
  }
}

function fromPreProfile(data) {
  return {
          firstname: checkFirstName(data.firstname),
          lastname: checkLastName(data.lastname),
          gender: /* FEMALE */0,
          mobile: {
            TAG: /* Ok */0,
            _0: undefined
          },
          email: {
            TAG: /* Ok */0,
            _0: ""
          },
          birthdate: ProfileBirthdate.fromISODateString(data.birthdate),
          address: {
            TAG: /* Ok */0,
            _0: ProfileAddress.empty(undefined)
          },
          occupation: undefined,
          family: /* Single */0,
          pdpa: /* Consent */{
            privacy: false,
            term: false
          }
        };
}

export {
  PDPA ,
  checkFirstName ,
  checkLastName ,
  checkMobilePhone ,
  checkEmail ,
  checkHookProfile ,
  reducer ,
  initial_state ,
  getValue ,
  checkState ,
  toJson$1 as toJson,
  parseCoupons ,
  getCoupons ,
  fromPreProfile ,
  
}
/* initial_state Not a pure module */
